import { render, staticRenderFns } from "./PartOrderListItem.vue?vue&type=template&id=ddf65c98&scoped=true&"
import script from "./PartOrderListItem.vue?vue&type=script&lang=js&"
export * from "./PartOrderListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf65c98",
  null
  
)

export default component.exports